import Box from "@mui/material/Box";
import * as React from "react";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import CommentIcon from "@mui/icons-material/Comment";
import SendIcon from "@mui/icons-material/Send";
import { FixedSizeList } from "react-window";
import { useState } from "react";
import "./style.css";
import { selectProfiles, selectUser } from "../../ProfileSlice";
import { useSelector } from "react-redux";

export const Comment = (props) => {
  return (
    <ListItem alignItems="flex-start">
      <ListItemAvatar>
        <Avatar alt={props.alt} src={props.src} />
      </ListItemAvatar>
      <ListItemText
        primary={props.userName}
        secondary={
          <React.Fragment>
            <Typography
              sx={{ display: "inline" }}
              component="span"
              variant="body2"
              color="text.primary"
            >
              {props.subject}
            </Typography>
            {" " + props.date}
          </React.Fragment>
        }
      />
    </ListItem>
  );
};

const Blog = () => {
  let today = new Date();
  const [change, setChange] = useState("");
  const [comments, setComment] = useState([]);

  const handelSubmit = (par) => {
    let copy = [...comments];
    par !== "" && copy.push(par);
    setComment(copy);
  };

  const profiles = useSelector(selectProfiles);
  const user = useSelector(selectUser);

  return (
    <div className="flexability">
      <Box className="blog-container backgroung-creme">
        <Box className="blog">
          <List className="comments-container">
            <Comment
              alt="Remy Sharp"
              src="https://www.aceshowbiz.com/images/photo/gary_oldman.jpg"
              userName="Remy Sharp"
              subject="Brunch this weekend?"
              date="17:13"
            />
            <Divider variant="inset" component="li" />
            <Comment
              alt="Travis Howard"
              src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
              userName="Travis Howard"
              subject="Wish I could come, but I'm out of town this…"
              date="17:23"
            />
            <Divider variant="inset" component="li" />
            <Comment
              alt="Cindy Baker"
              src="https://t3.ftcdn.net/jpg/03/17/23/90/360_F_317239009_UW4LCUmTHOxYyH4W9RHTIsslLygTonc9.jpg"
              userName="Cindy Baker"
              subject="Anyone saw the new shop downsters???"
              date="18:43"
            />
            {comments.map((comment) => {
              return (
                <div>
                  <Divider variant="inset" component="li" />
                  <Comment
                    alt="Cindy Baker"
                    src={profiles[user.email].photo}
                    userName={
                      profiles[user.email].firstName +
                      " " +
                      profiles[user.email].lastName
                    }
                    subject={comment}
                    date={
                      today.getHours() +
                      ":" +
                      (today.getMinutes() < 10
                        ? "0" + today.getMinutes()
                        : today.getMinutes())
                    }
                  />
                </div>
              );
            })}
          </List>
          <FormControl className="add-comment-container" variant="standard">
            <InputLabel
              className="comment-lable"
              htmlFor="input-with-icon-adornment"
            ></InputLabel>
            <Avatar
              className="add-comment-avatar"
              alt="Cindy Baker"
              src={profiles[user.email].photo}
            />
            <Input
              className="comment-input"
              id="input-with-icon-adornment"
              placeholder="Message"
              onChange={(e) => setChange(e.target.value)}

              endAdornment={
                <InputAdornment position="end">
                  <Button
                    variant="text"
                    onClick={() => {
                      handelSubmit(change);
                    }}
                  >
                    <SendIcon />
                  </Button>
                </InputAdornment>
              }
            />
          </FormControl>
        </Box>
      </Box>
    </div>
  );
};

export default Blog;
